import axios, { AxiosResponse } from 'axios'
import environment from '@shared/config/environments'
import { CmsApi } from '@generated/api'
import { DboPrintFormsApi } from '@api/ump-dboPrintForms'
import { ControllerApi as EwalletProfileApi } from '@api/ump-ewalletProfile'
import { OtpSenderServiceApi } from '@api/ump-otp-sender'
import { CatalogManagerApi } from '@api/ump-catalog-manager'
import { ControllerApi as EwalletApi } from '@api/ump-ewallet'
import { ControllerApi as EwcatApi } from '@api/ump-ewcat'
import { ControllerApi as PlatSdkGatewayApi } from '@api/ump-plat-sdk-gateway'

/**
 * todo Требуется отрефакторить работу с апи (создать фабрику апи для ump, cms, .net)
 */
const cmsApi = new CmsApi({ basePath: environment.api.autoPayments })
/**
 * todo basePath нужно брать из environment, требуется отрефакторить environment, чтобы можно было указывать разные сервера,
 *  порт брать из конфига сервера или передавать через параметр при запуске сервера
 */

/*
@TODO: set one NEXT_PUBLIC_UMP_PATH variable when set NODE_ENV=env(development|test|production)
 */
export const umpPathMapping = {
  development: process.env.NEXT_PUBLIC_UMP_PATH,
  test: process.env.NEXT_PUBLIC_UMP_PATH,
  production: process.env.NEXT_PUBLIC_UMP_PATH,
}

export const cmsPathMapping = {
  development: process.env.NEXT_PUBLIC_CMS_PATH,
  test: process.env.NEXT_PUBLIC_CMS_PATH,
  production: process.env.NEXT_PUBLIC_CMS_PATH,
}

export const baseUmpPath = umpPathMapping[process.env.BUILD_ENV as string] || umpPathMapping.production
export const baseCmsPath = cmsPathMapping[process.env.BUILD_ENV as string] || cmsPathMapping.production

const dboPrintFormsApi = new DboPrintFormsApi({
  basePath: baseUmpPath,
})

const getWallet = (): Promise<AxiosResponse<{ phone: string }>> =>
  axios.post(`${baseUmpPath}/ewallet-profile/api/v1/getWallet`, {})

const ewalletProfileApi = new EwalletProfileApi({
  basePath: baseUmpPath,
})

const otpSenderApi = new OtpSenderServiceApi({
  basePath: baseUmpPath,
})

const catalogManagerApi = new CatalogManagerApi({
  basePath: baseUmpPath,
})

const ewalletApi = new EwalletApi({
  basePath: baseUmpPath,
})

const ewcatApi = new EwcatApi({
  basePath: baseUmpPath,
})

const platSdkGatewayApi = new PlatSdkGatewayApi({
  basePath: baseUmpPath,
})

export {
  dboPrintFormsApi,
  cmsApi,
  getWallet,
  ewalletProfileApi,
  otpSenderApi,
  catalogManagerApi,
  ewalletApi,
  ewcatApi,
  platSdkGatewayApi,
}
